const topics = [
  { name: '台北娜娜', heat: '128万', color: 'bg-primary-500' },
  { name: '莫里秀', heat: '96万', color: 'bg-primary-500' },
  { name: '玩偶姐姐', heat: '87万', color: 'bg-primary-500' },
  { name: '明星塌房', heat: '73万', color: 'bg-accent-500' },
  { name: '网红互撕', heat: '65万', color: 'bg-accent-500' },
  { name: '直播翻车', heat: '52万', color: 'bg-accent-500' },
  { name: '娱乐圈内幕', heat: '48万', color: 'bg-secondary-500' },
  { name: '素人爆料', heat: '41万', color: 'bg-secondary-500' },
  { name: '恋情曝光', heat: '37万', color: 'bg-secondary-500' },
  { name: '人设崩塌', heat: '33万', color: 'bg-accent-500' },
  { name: '税务风波', heat: '29万', color: 'bg-secondary-500' },
];

export default function SectionTopics() {
  return (
    <section id="topics" className="scroll-mt-20 py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-5xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            全网最热话题标签，点击探索你最关心的吃瓜方向
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, i) => (
            <a
              key={i}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="flex items-center gap-2 px-4 py-2.5 bg-background-100 hover:bg-background-200 rounded-full transition-all duration-200 cursor-pointer group"
            >
              <span className={`w-2 h-2 rounded-full ${topic.color} shrink-0`}></span>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                {topic.name}
              </span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">{topic.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}